<template>
    <div class='inline-card-cont'>
        <div class='size-1-2'>
            <ai-form-radio-box
                ref="radioRef"
                :meta='meta.radioMeta'
                :noClass="true"
                :callbacks="{userDataChanged: changeRadio}"
            />
        </div>
        <div class='size-1-1'>
            <ai-form-select-box
                v-if='dep === 102276625'
                :meta='selectMeta'
                :callbacks="{userDataChanged: changeSelect}"
            />
            <ai-form-text-box-readonly
                v-else
                :meta='{fieldNameText: meta.statusField, title: "Статус"}'
                :server-data='ServerDataStatusValue'
            />
        </div>
        <div class='size-1-1' v-if='meta.dogVisible'>
            <ai-form-text-box-readonly
                :meta='{fieldNameText: meta.nDogMeta.fieldNameText, title: meta.nDogMeta.title}'
                :server-data='serverData'
            />
            <!-- ai-form-select-box :meta='meta.selectBoxMeta' />-->
        </div>
        <div class='size-1-1 tep-btn-cont' v-if='meta.dogVisible'>
            <dx-button
                icon="/infoenergo/assets/tep/tep-tree-menu/menu_item_2.svg"
                text='Любой договор'
                @click='openDog'></dx-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tep-opu-parameters-row'
}
</script>
<script setup>
import { DxButton} from 'devextreme-vue';
import { dxUiNotify } from '@/utils/dx-helper';
import AiFormTextBoxReadonly from '@/components/card-component/ai-form-text-box-readonly.vue';
import AiFormSelectBox from '@/components/card-component/ai-form-select-box.vue';
import { inject, computed, onMounted, ref } from 'vue';
import AiFormRadioBox from '@/components/card-component/ai-form-radio-box.vue';
import tepCardsStore from '@/views/tep/tep-grid/store/tep-cards-store';
import { getCookie } from '@/utils/cookies';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

const radioRef = ref(null);
const userData = inject('userData');

onMounted(() => {
    radioRef.value.userDataChange('active_prib');
});

const ServerDataStatusValue = computed(() => {
    const data = {
        ... props.serverData,
        pr_active: props.serverData[props.meta.statusField] === 0 ? 'Допуск' : 'Недопуск',
    }
    return data;
});

const dep = computed(() => {
    return +getCookie('dep');
});

const changeRadio = () => {
    const radioValNew = userData.value[props.meta.radioMeta.fieldNameText];
    const radioValOld = tepCardsStore.state.radioPribFlag;
    if(radioValNew && radioValNew != radioValOld) {
        tepCardsStore.changeRadioVal(radioValNew);
    }
}

const changeSelect = (() => {
    if(props.serverData[props.meta.statusField] !== userData.value[props.meta.statusField]) {
        if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
    }
});

const selectMeta = {
    title: 'Статус',
    fieldNameText: 'pr_active',
    fieldNameId: 'pr_active_name',
    showClearButton: false,
    extParams: {
        displayExpr: 'name',
        valueExpr: 'kod',
        dictionaryRoutePath: 'tep-grid./tep/lookup-uu-status/get',
    },
};

const openDog = () => {
    dxUiNotify('Функция в разработке', 'info', 3000);
}
</script>

<style scoped>
.tep-btn-cont {
    padding-top: 18px;
}
.tep-btn-icon {
    height: 1em;
    width: auto;
    margin-right: 0.8em;
}
.inline-card-cont {
    display: flex;
    align-items: center;
    min-width: 800px;
}
.inline-card-cont :deep(.dx-field) {
    margin: 0 10px;
}
</style>
